export default "/_next/static/images/proactive-support-icon-legacy-1bb115ab49e839df0adc41ae12d98214.svg";